import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./ContactForm.css";

import "bootstrap/dist/css/bootstrap.min.css";

import Select from "react-select";

import countryList from "react-select-country-list";

const officeData = [
  {
    id: "angola",
    name: "Angola Office",
    phone: "971-058-627-9149",
    email: "connect@tnsglobal.co",
    location: "Edifício Maianga, 5th Floor, C section",
  },
];

function ContactForm({ isContactPage }) {
  const [activeOffice] = useState(officeData[0]);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    company: "",
    country: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [countryError, setCountryError] = useState(false);

  const countryOptions = countryList().getData();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Email validation
  const emailRegex =
    /^[^\s@,]+@[^\s@,]+\.[a-zA-Z]{2,}$/;

  useEffect(() => {
    if (!status) return;

    const timer = setTimeout(() => {
      setStatus("");
    }, 3000);

    return () => clearTimeout(timer);
  }, [status]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Full name validation
    if (!formData.fullName.trim()) {
      return setStatus("Please enter your full name.");
    }

    // Email empty validation
    if (!formData.email.trim()) {
      return setStatus("Please enter your email.");
    }

    // Email format validation
    if (!emailRegex.test(formData.email.trim())) {
      return setStatus("Please enter a valid email address.");
    }

    // Company validation
    if (!formData.company.trim()) {
      return setStatus("Please enter your company.");
    }

    // Country validation
    if (!formData.country) {
      setCountryError(true);
      return setStatus("Please select your country.");
    }

    setCountryError(false);

    // Message validation
    if (!formData.message.trim()) {
      return setStatus("Please enter your message.");
    }

    // CAPTCHA validation
    if (!isVerified) {
      return setStatus("Please verify that you are not a robot.");
    }

    setLoading(true);

    const languageMap = {
      en: "ENG",
      fr: "FRA",
      pt: "POR",
    };

    const language =
      languageMap[localStorage.getItem("language")] || "ENG";

    try {
      const response = await fetch(
        // "https://tnsadmin.tnsglobal.co/api/TnsAPI/AddEnquiry", UAT
        "https://admin.tnsglobal.co/api/TnsAPI/AddEnquiry", //Production
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            fullName: formData.fullName.trim(),
            email: formData.email.trim(),
            company: formData.company.trim(),
            country: formData.country.trim(),
            message: formData.message.trim(),
            language,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
          Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Message sent successfully! Thankyou.",
                confirmButtonText: "OK",
              });
        // setStatus("Message sent successfully!");

        setFormData({
          fullName: "",
          email: "",
          company: "",
          country: "",
          message: "",
        });

        setIsVerified(false);
      } else {
        setStatus(data.message || "Failed to send message.");
      }
    } catch (err) {
      console.log(err);
      setStatus("Failed to send message.");
    }

    setLoading(false);
  };

  return (
    <section id="contact-form"
      className={`contact-wrapper section-padding ${
        isContactPage ? "" : "home-page"
      }`}
    >
      {/* LEFT SIDE */}
      <div className="contact-left">
        <span
          className="contact-tag"
          style={{
            color: isContactPage ? "" : "#FFFFFF",
          }}
        >
          PARTNER WITH US
        </span>

        <h2
          className="heading-title"
          style={{
            textAlign: "left",
            color: isContactPage ? "" : "#FFFFFF",
            fontSize: "22px",
          }}
        >
          Connect With TNS Global
        </h2>

        <p
          className="desc contact-desc"
          style={{
            textAlign: "left",
            justifySelf: "start",
            width: "100%",
            color: isContactPage ? "" : "#FFFFFFB2",
            fontSize: "17px",
          }}
        >
          Ready to take the first step towards unlocking opportunities,
          realizing goals, and embracing innovation? We're here and eager to
          connect.
        </p>

        <div className="contact-list">
          {/* PHONE */}
          <a
            href={`tel:${activeOffice.phone.replace(/[^0-9+]/g, "")}`}
            className="contact-row contact-link"
          >
            <div className="icon-circle">
              <img
                src={
                  isContactPage
                    ? "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/phone.svg"
                    : "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/phone-white.svg"
                }
                alt=""
              />
            </div>

            <div>
              <span
                className="contact-small"
                style={{
                  color: isContactPage ? "" : "#FFFFFFE5",
                }}
              >
                TO MORE INQUIRY
              </span>

              <h5
                style={{
                  color: isContactPage ? "" : "#FFFFFF",
                }}
              >
                {activeOffice.phone}
              </h5>
            </div>
          </a>

          {/* WHATSAPP */}
          <a
            href={`https://wa.me/${activeOffice.phone.replace(
              /[^0-9]/g,
              ""
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-row contact-link"
          >
            <div className="icon-circle">
              <img
                src={
                  isContactPage
                    ? "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/bluewhatsapp.svg"
                    : "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/whatsapp-white.svg"
                }
                alt=""
              />
            </div>

            <div>
              <span
                className="contact-small"
                style={{
                  color: isContactPage ? "" : "#FFFFFFE5",
                }}
              >
                TO WHATSAPP
              </span>

              <h5
                style={{
                  color: isContactPage ? "" : "#FFFFFF",
                }}
              >
                {activeOffice.phone}
              </h5>
            </div>
          </a>

          {/* EMAIL */}
          <a
            href={`mailto:${activeOffice.email}`}
            className="contact-row contact-link"
          >
            <div className="icon-circle">
              <img
                src={
                  isContactPage
                    ? "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/email.svg"
                    : "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/mail-white.svg"
                }
                alt=""
              />
            </div>

            <div>
              <span
                className="contact-small"
                style={{
                  color: isContactPage ? "" : "rgba(255, 255, 255, 0.9)",
                  opacity: "0.8",
                }}
              >
                TO SEND MAIL
              </span>

              <h5
                style={{
                  color: isContactPage ? "" : "#FFFFFF",
                }}
              >
                {activeOffice.email}
              </h5>
            </div>
          </a>
        </div>

        <div className="contact-divider"></div>

        <div className="social-box">
          <p
            style={{
              color: isContactPage ? "" : "#FFFFFF",
            }}
          >
            Social Just You Connected Us!
          </p>

          <div className="social-icons">
            <a
              href="https://www.linkedin.com/company/106948931/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  isContactPage
                    ? "/assets/newlink.svg"
                    : "/assets/whitelink.svg"
                }
                alt=""
              />
            </a>

            <a
              href="https://www.facebook.com/people/TNS-Global/61579914372332/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  isContactPage
                    ? "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/facebook.svg"
                    : "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/facebook-white.svg"
                }
                alt=""
              />
            </a>

            <a
              href="https://www.instagram.com/tnsglobal_sabre/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="instagram-icon"
                src={
                  isContactPage
                    ? "/assets/insta.svg"
                    : "/assets/insta-white.svg"
                }
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="contact-right">
        <div className="contact-right-div">
          <h2>Fill out the form below</h2>

          <p>
            Tell us about your business, and we'll be in touch.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            {/* Full Name */}
            <div className="col-md-6">
              <div className="floating-input">
                <input
                  type="text"
                  name="fullName"
                  className="form-control custom-input"
                  placeholder=" "
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />

                <label>Full Name</label>
              </div>
            </div>

            {/* Email */}
            <div className="col-md-6">
              <div className="floating-input">
                <input
                  type="email"
                  name="email"
                  className="form-control custom-input"
                  placeholder=" "
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label>Email</label>
              </div>
            </div>

            {/* Company */}
            <div className="col-md-6">
              <div className="floating-input">
                <input
                  type="text"
                  name="company"
                  className="form-control custom-input"
                  placeholder=" "
                  value={formData.company}
                  onChange={handleChange}
                  required
                />

                <label>Company</label>
              </div>
            </div>

            {/* Country */}
            <div className="col-md-6">
              <div className="floating-select">
                <Select
                  options={countryOptions}
                  placeholder=" "
                  className={countryError ? "country-error" : ""}
                  value={
                    formData.country
                      ? countryOptions.find(
                          (c) => c.label === formData.country
                        )
                      : null
                  }
                  onChange={(selected) => {
                    setCountryError(false);

                    setFormData((prev) => ({
                      ...prev,
                      country: selected ? selected.label : "",
                    }));
                  }}
                />

                <label
                  className={
                    formData.country
                      ? "floating-label active"
                      : "floating-label"
                  }
                >
                  Select Country
                </label>
              </div>
            </div>

            {/* Message */}
            <div className="col-12">
              <div className="floating-input floating-textarea">
                <textarea
                  rows="5"
                  name="message"
                  className="form-control custom-input"
                  placeholder=" "
                  value={formData.message}
                  onChange={handleChange}
                  required
                />

                <label>Message</label>
              </div>
            </div>
          </div>

          {/* CAPTCHA */}
          <div className="captcha-box">
            <label className="captcha-custom">
              <input
                type="checkbox"
                checked={isVerified}
                onChange={(e) =>
                  setIsVerified(e.target.checked)
                }
              />

              <span className="checkmark"></span>

              <span className="captcha-text">
                I'm not a robot
              </span>

              <div className="captcha-brand">
                <img
                  src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
                  alt=""
                />

                <small>reCAPTCHA</small>

                <span>Privacy - Terms</span>
              </div>
            </label>
          </div>

          {/* Submit */}
          <div className="read-btn-a">
            <button
              type="submit"
              className="read-btn"
              disabled={loading}
            >
              {loading ? "Submitting..." : "SUBMIT"}

              <img
                src="/assets/arrow.svg"
                alt=""
                className="btn-arrow"
              />
            </button>
          </div>

          {/* Status */}
          {status && (
            <p
              style={{
                marginTop: 20,
                color: status.includes("success")
                  ? "green"
                  : "red",
              }}
            >
              {status}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

export default ContactForm;